//
//
//
//
import echarts from "echarts";
import { debounce } from '@/utils';
export default {
  props: ["chartData", "lendName", "total"],
  data: function data() {
    return {
      chart: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.initChart();
    this.__resizeHanlder = debounce(function () {
      if (_this.chart) {
        _this.chart.resize();
      }
    }, 100);
    window.addEventListener("resize", this.__resizeHanlder);
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }

    this.chart.dispose();
    this.chart = null;
    window.removeEventListener('resize', this.__resizeHanlder);
  },
  watch: {
    chartData: {
      deep: true,
      handler: function handler(val) {
        this.setOptions(val);
      }
    }
  },
  methods: {
    setOptions: function setOptions() {
      this.chart.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c}个"
        },
        title: {
          itemGap: 0,
          text: "总数",
          subtext: this.total + "个",
          x: "center",
          top: "35%",
          textAlign: "center",
          left: "44%",
          textStyle: {
            fontSize: "16",
            fontWeight: "bolder",
            color: ["#8C8C8C"]
          },
          subtextStyle: {
            lineHeight: 26,
            rich: {
              a: {}
            },
            color: "#8C8C8C",
            fontSize: "16"
          }
        },
        // legend: {
        //     orient: 'vertical',
        //     x: 'right',
        //     left: '70%',
        //     data: this.lendName,
        //     width: '50%',
        //     align: 'left',
        //     textStyle: {
        //         fontSize: 12,
        //         color: 'normal'
        //     },
        //     itemHeight: 10,
        //     itemWidth: 10,
        //     top: '20',
        //     selectedMode: false
        // },
        series: [{
          type: "pie",
          radius: ["60%", "82%"],
          center: ["45%", "50%"],
          color: ["rgb(42,184,254)", "rgb(245,214,0)", "#4ECB73"],
          textStyle: ["rgb(42,184,254)", "rgb(245,214,0)", "#4ECB73"],
          width: "100%",
          label: {
            show: false // position: 'center'

          },
          labelLine: {
            normal: {
              length: 1
            }
          },
          data: [{
            value: this.chartData[0],
            name: this.lendName[0],
            itemStyle: {
              normal: {
                label: {
                  textStyle: {
                    fontSize: "12"
                  },
                  show: true,
                  formatter: function formatter(params, option) {
                    if (params.data.value === 0) {
                      // params.data.itemStyle.normal.labelLine.show = false
                      params.data.label.normal.show = false;
                      params.data.labelLine.normal.show = false;
                    }
                  }
                },
                labelLine: {
                  show: true
                }
              }
            }
          }, {
            value: this.chartData[1],
            name: this.lendName[1],
            itemStyle: {
              normal: {
                label: {
                  textStyle: {
                    fontSize: "12"
                  },
                  show: true,
                  formatter: function formatter(params, option) {
                    if (params.data.value === 0) {
                      // params.data.itemStyle.normal.labelLine.show = false
                      params.data.label.normal.show = false;
                      params.data.labelLine.normal.show = false;
                    }
                  }
                },
                labelLine: {
                  show: true
                }
              }
            }
          }, {
            value: this.chartData[2],
            name: this.lendName[2],
            itemStyle: {
              normal: {
                label: {
                  textStyle: {
                    fontSize: "12"
                  },
                  show: true,
                  formatter: function formatter(params, option) {
                    if (params.data.value === 0) {
                      // params.data.itemStyle.normal.labelLine.show = false
                      params.data.label.normal.show = false;
                      params.data.labelLine.normal.show = false;
                    }
                  }
                },
                labelLine: {
                  show: true
                }
              }
            }
          }]
        }]
      });
    },
    initChart: function initChart() {
      console.log(this.chartData);
      this.chart = echarts.init(this.$refs.statusEchart, "macarons");
      this.setOptions(this.chartData);
    }
  }
};